<template>
  <div v-show="visible" class="part mt-4">
    <div class="header_style justify-content-start">
      <h2 class="h2_style mb-0">CSwitch</h2>
    </div>
 
    <div class="part__cnt">
      <div v-if="labelsHasData" class="label_style mt-3">
        <ul v-for="item in CswitchValue" :key="item.label">
          <li>{{ item.label }}</li>
          <li>{{ item.value }}</li>
        </ul>
      </div>

      <div v-show="secondData?.CSwitch?.length" class="position-relative">
        <div id="cswitch" style="width: 100%; height: 400px"></div>
        <label-list ref="labelList1" :perf_second_data="perf_second_data" chartKey="cswitch_chart" />
        <chart-rect ref="chartRect1" chartKey="cswitch_chart" />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart, arrNotEmpty} from '../common.js'
import ChartRect from '../rect.vue'

const useCharts = {
  props: {
    chartSettings: Object,
    perf_second_data: Object,
  },

  data() {
    return {
    }
  },

  computed: {
    secondData() {
      return this.perf_second_data?.['GPU']?.rows || {}
    },

    xData() {
      return this.gpuRows?.timeline
    },
  },

  methods: {
    getOption() {
      return {
        title: {
          text: "CSwitch",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: [
          {
            name: "CSwitch",
            type: "line",
            showSymbol: false,
            data: this.secondData?.["CSwitch"],
            itemStyle: this.chartSettings.itemStyle2,
          },
        ],
      }
    },

    drawPieChartCsWitch() {
      let chartDom = document.getElementById("cswitch")
      if (!chartDom) return
      if (!allChart.cswitch_chart) {
        allChart.cswitch_chart = echarts.init(chartDom)
      }
      allChart.cswitch_chart.setOption(this.getOption(), {notMerge: true})
    },
  }
}

export default {
  mixins: [useCharts],

  components: {LabelList, ChartRect},

  inject: ['injectObj'],

  props: {
    testInfo: Object,
    testInfo3: Object,
  },

  data() {
    return {
      
    }
  },

  computed: {
    project() {
      return this.$route.query.project
    },

    isAllChecked() {
      return this.injectObj.isAllChecked
    },

    CswitchValue() {
      let data = this.testInfo3
      
      return [
        {
          label: "Avg(CSwitch)",
          value:
            JSON.stringify(data) === "{}"
              ? "-"
              : data?.custom_data == null ||
                data?.custom_data == undefined ||
                data?.custom_data == "-"
              ? ""
              : JSON.parse(data?.custom_data || "{}")?.CSwitch
              ? JSON.parse(data?.custom_data || "{}")?.CSwitch
              : "-",
        },
      ];
    },

    labelsHasData() {
      return arrNotEmpty(this.CswitchValue)
    },

    visible() {
      return this.labelsHasData || this.secondData?.CSwitch?.length
    },
  },

  methods: {
    async init(isMounted) {
      this.drawPieChartCsWitch()
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)
    }
  }
}
</script>

<style scoped>
@import "../common.css"
</style>